import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  micLevel: 0,
  isTranscriptTimeout: false,
};

const microphoneSlice = createSlice({
  name: 'microphone',
  initialState,
  reducers: {
    setMicLevel: (state, action) => {
      state.micLevel = action.payload;
    },
    setIsTranscriptTimeout: (state, action) => {
      state.isTranscriptTimeout = action.payload;
    },
    resetMicrophoneState: (state) => {
      state.micLevel = 0;
      state.isTranscriptTimeout = false;
    },
  },
});

export const { setMicLevel, setIsTranscriptTimeout, resetMicrophoneState } =
  microphoneSlice.actions;

// Selectors
export const selectMicLevel = (state) => state.microphoneState.micLevel;
export const selectIsTranscriptTimeout = (state) =>
  state.microphoneState.isTranscriptTimeout;
export const selectMicrophoneState = (state) => state.microphoneState;

export default microphoneSlice.reducer;
